module.exports = __webpack_public_path__ + "assets-cabinet/img/profile-icon.9eec2105.svg";